import { createSlice } from "@reduxjs/toolkit";

// Load initial state from sessionStorage
const loadInitialState = () => {
  // Check if we're in browser environment
  if (typeof window === 'undefined') return null;
  
  try {
    const savedMechanic = sessionStorage.getItem('selectedMechanic');
    return savedMechanic ? JSON.parse(savedMechanic) : null;
  } catch (error) {
    return null;
  }
};

export const mechanicSlice = createSlice({
  name: "mechanic",
  initialState: loadInitialState(),

  reducers: {
    setMechanic: (_, action) => {
      const { payload } = action;

      const mechanicDefaultBranch =
        payload.defaultSelectedBranch ||
        payload.branchList.find((branch) => branch.isDefault);

      let mechanicData;
      if (mechanicDefaultBranch) {
        const { name: branchName, id: branchId } = mechanicDefaultBranch;
        mechanicData = { ...payload, selectedBranch: { branchName, branchId } };
      } else {
        mechanicData = { ...payload, selectedBranch: null };
      }

      // Persist to sessionStorage
      try {
        sessionStorage.setItem('selectedMechanic', JSON.stringify(mechanicData));
      } catch (error) {
        // Silently fail if sessionStorage is not available
      }

      return mechanicData;
    },

    setSelectedBranch: (state, action) => {
      const { payload: selectedBranch } = action;
      const updatedState = { ...state, selectedBranch };
      
      // Persist updated state to sessionStorage
      try {
        sessionStorage.setItem('selectedMechanic', JSON.stringify(updatedState));
      } catch (error) {
        // Silently fail if sessionStorage is not available
      }
      
      return updatedState;
    },

    clearMechanic: () => {
      // Remove from sessionStorage
      try {
        sessionStorage.removeItem('selectedMechanic');
      } catch (error) {
        // Silently fail if sessionStorage is not available
      }
      return null;
    },
  },
});

export const { setMechanic, setSelectedBranch, clearMechanic } =
  mechanicSlice.actions;

export function selectMechanicId(state) {
  const { mechanic } = state;
  if (mechanic) {
    return mechanic.id;
  }
  return null;
}

export default mechanicSlice.reducer;
